import { PersonFaceSource } from 'components/person-avatar';

/**
 * Rosto de um participante (`target` da realização) para o `PersonAvatar`: os mesmos campos que o `TaskItem`
 * passava ao `UserAvatar` (`{ ...pessoa, ...pessoa.extra }`): foto em `image.small.url`, avatar montado em `avatar`
 * e a escolha da pessoa em `avatar_type`.
 */
export function rostoDoParticipante(pessoa: any): PersonFaceSource {
  const dados = { ...pessoa, ...pessoa?.extra };
  return { image: dados.image?.small?.url, avatar: dados.avatar, avatarType: dados.avatar_type };
}

/** Rosto de quem cadastrou: `owner_avatar` da leitura, o mesmo objeto que o `TaskItem` passava ao `UserAvatar`. */
export function rostoDoAutor(data: any): PersonFaceSource {
  return rostoDoParticipante(data?.owner_avatar ?? {});
}

/** Nome de uma pessoa nas telas da Realização Destaque: nome de guerra, senão o nome, senão a matrícula. */
export function nomeDoParticipante(pessoa: any): string {
  return pessoa?.extra?.nome_guerra || pessoa?.name || pessoa?._id || '';
}
